const styles = theme => {
  /* Bin cell heights — scaled up so the kiosk layout fills the right panel */
  const BIN_MIN_H = '34px';
  const BIN_GRID_ROW = '34px';
  const BIN_TABLE_CELL_H = '48px';
  const COOL_ROW_8 = '7.15rem';
  const COOL_ROW_12 = '4.9rem';
  const COOL12_COL = '8.5rem';
  const M41_GRID_LAST_ROW = '5.25rem';
  const COOL12_BIN_MIN = '4.25rem';

  const binBase = {
    padding: '3px 4px',
    textAlign: 'center',
    width: '100%',
    minHeight: BIN_MIN_H,
    height: 'auto',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: 600,
    borderRadius: '6px',
    border: '1px solid transparent',
    boxShadow: 'none',
    letterSpacing: '0.02em',
    lineHeight: 1.1,
    transition: 'transform 0.12s ease, box-shadow 0.12s ease',
    '&.MuiPaper-root': {
      boxShadow: 'none',
    },
  };

  return {
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    tableCell: {
      border: "1px solid #e2e8f0",
      textAlign: "center",
      verticalAlign: "middle",
      height: BIN_TABLE_CELL_H,
      padding: "6px",
    },
    centerCell: {
      border: "1px solid #e2e8f0",
      textAlign: "center",
      verticalAlign: "middle",
      height: "100px",
      padding: "6px",
    },
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'grid',
      width: '100%',
    },
    title: {
      fontSize: '0.9rem',
      fontWeight: '600',
      color: '#0369a1',
      display: 'grid',
      justifyContent: 'center',
      margin: '4px 0 8px',
    },
    ratingContainer: {
      fontWeight: '500',
      color: '#0369a1',
      display: 'grid',
      width: '100%',
      marginBottom: '4px',
      fontSize: '0.75rem',
    },
    linkLabel: {
      color: '#94a3b8'
    },
    /* Empty / available */
    gridback: {
      ...binBase,
      background: '#f8fafc',
      color: '#334155',
      borderColor: '#cbd5e1',
    },
    /* Assigned — amber */
    gridBlueback: {
      ...binBase,
      background: '#fbbf24',
      color: '#422006',
      borderColor: '#f59e0b',
    },
    /* Stocked — green */
    gridOrangeback: {
      ...binBase,
      background: '#34d399',
      color: '#064e3b',
      borderColor: '#10b981',
    },
    /* Deactivate — red */
    gridRedback: {
      ...binBase,
      background: '#f87171',
      color: '#fff',
      borderColor: '#ef4444',
    },
    /* Hold — blue */
    gridSkyblueback: {
      ...binBase,
      background: '#60a5fa',
      color: '#fff',
      borderColor: '#3b82f6',
    },
    gridOrangebackCool:{
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#34d399',
      color: '#064e3b',
      borderColor: '#10b981',
    },
    gridBluebackCool:{
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#fbbf24',
      color: '#422006',
      borderColor: '#f59e0b',
    },
    gridSkybluebackCool:{
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#60a5fa',
      color: '#fff',
      borderColor: '#3b82f6',
    },
    gridRedbackCool: {
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#f87171',
      color: '#fff',
      borderColor: '#ef4444',
    },
    gridbackCool:{
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#f8fafc',
      color: '#334155',
      borderColor: '#cbd5e1',
    },
    /* Locked — violet */
    gridPurpleBin: {
      ...binBase,
      background: '#a78bfa',
      color: '#fff',
      borderColor: '#8b5cf6',
    },
    gridPurpleBinCool: {
      ...binBase,
      width: '100%',
      height: '100%',
      minHeight: 0,
      fontSize: '0.8rem',
      flexDirection: 'row',
      background: '#a78bfa',
      color: '#fff',
      borderColor: '#8b5cf6',
    },
    /* Selected / active */
    activeBin: {
      ...binBase,
      background: '#fb923c',
      color: '#7c2d12',
      borderColor: '#f97316',
      boxShadow: '0 0 0 2px rgba(249, 115, 22, 0.35)',
      pointerEvents: 'none !important',
    },
    RemoveMargin: {
      margin: '0!important',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    /* Shared unit / addon cabinet frame (same look as Cool fridge) */
    unitFrame: {
      border: '2px solid #94a3b8',
      borderRadius: '10px',
      background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
      padding: '6px',
      boxSizing: 'border-box',
      boxShadow: 'inset 0 2px 6px rgba(15, 23, 42, 0.06)',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '4px auto 8px',
      '& .MuiTooltip-root': {
        display: 'contents',
      },
    },
    /* L60 addon — 5 equal columns x 12 rows, no stretched/wrapped rows */
    l60Grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 6rem)',
      gridTemplateRows: `repeat(12, minmax(${BIN_GRID_ROW}, auto))`,
      columnGap: '5px',
      rowGap: '6px',
      width: 'fit-content',
      maxWidth: '100%',
      '& > .MuiGrid-container': {
        display: 'contents',
      },
      '& .MuiGrid-item': {
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        flexGrow: '0 !important',
        padding: '0 !important',
        width: '100% !important',
        minWidth: 0,
      },
      '& $binColCompact': {
        width: '100% !important',
        maxWidth: 'none !important',
      },
    },
    /* C28 / C30 — 12 tracks so middle BB spans line up with AA/CC rows */
    c28c30Grid: {
      display: 'grid',
      gridTemplateColumns: '54px 92px 54px',
      gridTemplateRows: `repeat(12, minmax(${BIN_GRID_ROW}, auto))`,
      columnGap: '2px',
      rowGap: '2px',
      width: 'fit-content',
      maxWidth: '100%',
      alignItems: 'stretch',
      justifyItems: 'stretch',
    },
    c28c30Cell: {
      minWidth: 0,
      minHeight: 0,
      height: '100%',
      width: '100%',
      boxSizing: 'border-box',
      '& > div': {
        height: '100% !important',
        width: '100% !important',
        minHeight: `${BIN_MIN_H} !important`,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    /* Cool 8 / Cool 12 — refrigerator-style compartments */
    coolFridgeCabinet: {
      border: '2px solid #94a3b8',
      borderRadius: '10px',
      background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
      padding: '6px',
      boxSizing: 'border-box',
      boxShadow: 'inset 0 2px 6px rgba(15, 23, 42, 0.06)',
      width: 'fit-content !important',
      maxWidth: '100%',
      margin: '4px auto 8px',
      display: 'grid',
      justifyContent: 'center',
      justifyItems: 'stretch',
      overflow: 'hidden',
      '& .MuiTooltip-root': {
        display: 'contents',
      },
    },
    coolFridgeGrid8: {
      gridTemplateColumns: 'repeat(2, 8rem)',
      gridTemplateRows: `repeat(4, ${COOL_ROW_8})`,
      gap: '6px',
      columnGap: '10px',
    },
    coolFridgeGrid12: {
      gridTemplateColumns: `repeat(2, ${COOL12_COL})`,
      gridTemplateRows: `repeat(6, ${COOL_ROW_12})`,
      gap: '4px',
      columnGap: '8px',
      '& > .MuiGrid-container': {
        display: 'contents',
      },
      '& .MuiGrid-item': {
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        flexGrow: '0 !important',
        padding: '0 !important',
        width: '100%',
      },
    },
    /* V12: door heights vs one HD36 bin — 2, 2, 1, 1, 3, 3 (12 standard bins). */
    v12Grid: {
      gridTemplateColumns: `repeat(2, ${COOL12_COL})`,
      gridTemplateRows: [
        `calc(${BIN_GRID_ROW} * 2)`,
        `calc(${BIN_GRID_ROW} * 2)`,
        BIN_GRID_ROW,
        BIN_GRID_ROW,
        `calc(${BIN_GRID_ROW} * 3)`,
        `calc(${BIN_GRID_ROW} * 3)`,
      ].join(' '),
      gap: '4px',
      columnGap: '8px',
      alignItems: 'stretch',
      '& > .MuiGrid-container': {
        display: 'contents',
      },
      '& .MuiGrid-item': {
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        flexGrow: '0 !important',
        padding: '0 !important',
        width: '100%',
        height: '100%',
        minHeight: '0 !important',
        alignSelf: 'stretch',
      },
      '& $binStyleCOOL12': {
        minHeight: '0 !important',
        height: '100% !important',
        maxHeight: '100% !important',
      },
    },
    coolUnitGrid: {
      width: 'fit-content',
      maxWidth: '100%',
      margin: '4px auto 8px',
      fontWeight: 500,
      color: '#0369a1',
      fontSize: '0.75rem',
    },
    coolUnitRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 8rem)',
      gap: '6px',
      columnGap: '10px',
      margin: '0 !important',
      width: 'fit-content !important',
      maxWidth: 'fit-content !important',
      '&.MuiGrid-root': {
        width: 'auto !important',
        margin: '0 !important',
      },
    },
    /* Cool 8 — taller doors, wider for AA/BB labels */
    coolBinCell8: {
      width: '100%',
      height: '100%',
      minHeight: 0,
      padding: '0 !important',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      '& > .MuiPaper-root, &.kioskDoorCool > .MuiPaper-root, &.disableCoolDoor > .MuiPaper-root': {
        flex: '1 1 auto',
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
        minHeight: '100% !important',
        fontSize: '0.8rem',
        borderRadius: '6px',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        flexDirection: 'row !important',
      },
    },
    /* Cool 12 */
    coolBinCell12: {
      width: '100%',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
      padding: '0 !important',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      '& > .MuiPaper-root, &.kioskDoor > .MuiPaper-root, &.deactiveBin > .MuiPaper-root, &.disabledDoor > .MuiPaper-root': {
        flex: '1 1 auto',
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
        minHeight: '0 !important',
        maxHeight: '100% !important',
        fontSize: '0.75rem',
        borderRadius: '6px',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        flexDirection: 'row !important',
      },
    },
    coolBinLabelWrap: {
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      gap: '4px',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    coolBinLabel: {
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.3em',
      lineHeight: 1.1,
      whiteSpace: 'nowrap',
    },
    coolBinLabelLetter: {
      display: 'inline',
      fontSize: '0.75rem',
      fontWeight: 700,
      letterSpacing: '0.02em',
      textAlign: 'center',
    },
    coolBinLabelNumber: {
      display: 'inline',
      fontSize: '0.75rem',
      fontWeight: 700,
      textAlign: 'center',
      fontVariantNumeric: 'tabular-nums',
    },
    coolBinLockIcon: {
      fontSize: '12px !important',
      lineHeight: 1,
      flexShrink: 0,
    },
    imageProperty: {
      height: '500px'
    },
    linkContent: {
      textDecoration: 'none'
    },
    kioskDoor: {
      cursor: 'pointer',
      maxWidth: 'none',
      minWidth: 0,
      padding: 0,
      '& > .MuiPaper-root': {
        width: '100% !important',
        height: '100%',
        minHeight: BIN_MIN_H,
      },
      '&:hover > div, &:hover > span, &:hover > .MuiPaper-root': {
        transform: 'translateY(-1px)',
        boxShadow: '0 3px 8px rgba(15, 23, 42, 0.14)',
      },
    },
    kioskDoorCool: {
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      padding: '0 !important',
      display: 'flex',
      flexDirection: 'column',
      '& > .MuiPaper-root': {
        flex: '1 1 auto',
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
      },
      '&:hover > div, &:hover > span, &:hover > .MuiPaper-root': {
        transform: 'translateY(-1px)',
        boxShadow: '0 3px 8px rgba(15, 23, 42, 0.14)',
      },
    },
    disabledDoor: {
      pointerEvents: 'none !important',
      padding: 0,
      maxWidth: 'none',
      minWidth: 0,
      cursor: 'not-allowed !important',
      opacity: '1 !important',
      '& > .MuiPaper-root': {
        width: '100% !important',
        height: '100%',
        minHeight: BIN_MIN_H,
      },
      '& $gridback, & $gridbackCool, & $gridBlueback, & $gridOrangeback, & $gridRedback, & $gridSkyblueback, & $gridPurpleBin, & .MuiPaper-root, & > div, & div[class*="grid"]': {
        background: '#e2e8f0 !important',
        backgroundColor: '#e2e8f0 !important',
        color: '#475569 !important',
        border: '1px solid #94a3b8 !important',
        opacity: '1 !important',
        boxShadow: 'none !important',
      },
    },
    disableCoolDoor: {
      pointerEvents: 'none !important',
      cursor: 'not-allowed !important',
      opacity: '1 !important',
      width: '100%',
      height: '100%',
      padding: '0 !important',
      display: 'flex',
      flexDirection: 'column',
      '& .MuiPaper-root, & > div': {
        background: '#e2e8f0 !important',
        backgroundColor: '#e2e8f0 !important',
        color: '#475569 !important',
        border: '1px solid #94a3b8 !important',
        boxShadow: 'none !important',
        opacity: '1 !important',
        flex: '1 1 auto',
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
      },
    },
    boxLayout: {
      padding: '6px 8px',
      boxShadow: 'none !important',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    binGridItem: {
      flex: '0 0 auto !important',
      padding: '1px !important',
      boxSizing: 'border-box',
    },
    /* M46 Main unit physical column proportions */
    binColA: {
      flex: '0 0 auto !important',
      width: '8.25rem !important',
      maxWidth: '8.25rem !important',
      padding: '1px !important',
      boxSizing: 'border-box',
      '& > .MuiPaper-root, & > div': {
        width: '100% !important',
      },
    },
    binColBC: {
      flex: '0 0 auto !important',
      width: '6.25rem !important',
      maxWidth: '6.25rem !important',
      padding: '1px !important',
      boxSizing: 'border-box',
      '& > .MuiPaper-root, & > div': {
        width: '100% !important',
      },
    },
    binColDE: {
      flex: '0 0 auto !important',
      width: '4.75rem !important',
      maxWidth: '4.75rem !important',
      padding: '1px !important',
      boxSizing: 'border-box',
      '& > .MuiPaper-root, & > div': {
        width: '100% !important',
      },
    },
    binColCompact: {
      flex: '0 0 auto !important',
      width: '6rem !important',
      maxWidth: '6rem !important',
      padding: '1px !important',
      boxSizing: 'border-box',
      '& > .MuiPaper-root, & > div': {
        width: '100% !important',
      },
    },
    mainUnitGrid: {
      display: 'grid',
      /* M46 Main: A large, B/C medium, D/E small — 12 equal rows */
      gridTemplateColumns: '8.5rem 5.75rem 5.75rem 4.25rem 4.25rem',
      gridTemplateRows: `repeat(12, minmax(${BIN_GRID_ROW}, auto))`,
      columnGap: '5px',
      rowGap: '6px',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto 4px',
      alignItems: 'stretch',
      justifyItems: 'stretch',
    },
    /* M41 has 11 rows — last row is taller */
    mainUnitGridM41: {
      display: 'grid',
      gridTemplateColumns: '8.5rem 5.75rem 5.75rem 4.25rem 4.25rem',
      gridTemplateRows: `repeat(10, minmax(${BIN_GRID_ROW}, auto)) minmax(${M41_GRID_LAST_ROW}, auto)`,
      columnGap: '5px',
      rowGap: '6px',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto 4px',
      alignItems: 'stretch',
      justifyItems: 'stretch',
    },
    /* M22: A+B display on left (rows 1-7), C full height */
    m22Grid: {
      display: 'grid',
      gridTemplateColumns: '6.5rem 6.5rem 6.5rem',
      gridAutoRows: `minmax(${BIN_GRID_ROW}, auto)`,
      columnGap: '5px',
      rowGap: '6px',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto 4px',
      alignItems: 'stretch',
      justifyItems: 'stretch',
    },
    m22DisplayPanel: {
      gridColumn: '1 / 3',
      gridRow: '1 / 8',
      borderRadius: '6px',
      background: '#f8fafc',
      border: '1px solid #cbd5e1',
      boxShadow: 'none',
      padding: '4px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'stretch',
      pointerEvents: 'none',
      zIndex: 1,
      minHeight: 0,
    },
    /* M24: A+B display on left (rows 1-6), C full height */
    m24Grid: {
      display: 'grid',
      gridTemplateColumns: '6.5rem 6.5rem 6.5rem',
      gridAutoRows: `minmax(${BIN_GRID_ROW}, auto)`,
      columnGap: '5px',
      rowGap: '6px',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto 4px',
      alignItems: 'stretch',
      justifyItems: 'stretch',
    },
    m24DisplayPanel: {
      gridColumn: '1 / 3',
      gridRow: '1 / 7',
      borderRadius: '6px',
      background: '#f8fafc',
      border: '1px solid #cbd5e1',
      boxShadow: 'none',
      padding: '4px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'stretch',
      pointerEvents: 'none',
      zIndex: 1,
      minHeight: 0,
    },
    kioskDisplayPanel: {
      gridColumn: '2 / 4',
      gridRow: '1 / 8',
      borderRadius: '6px',
      background: '#f8fafc',
      border: '1px solid #cbd5e1',
      boxShadow: 'none',
      padding: '4px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'stretch',
      pointerEvents: 'none',
      zIndex: 1,
      minHeight: 0,
    },
    kioskDisplayInner: {
      flex: 1,
      borderRadius: '6px',
      background: '#f1f5f9',
      border: '1px solid #e2e8f0',
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      color: '#64748b',
      fontSize: '0.85rem',
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },
    columnMappingNotice: {
      margin: '0 6px 6px',
      padding: '6px 10px',
      borderRadius: '8px',
      border: '1px solid #bae6fd',
      backgroundColor: '#f0f9ff',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      boxSizing: 'border-box',
    },
    columnMappingNoticeIcon: {
      flexShrink: 0,
      width: '22px',
      height: '22px',
      borderRadius: '6px',
      backgroundColor: '#e0f2fe',
      color: '#0369a1',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '1px',
      '& .MuiSvgIcon-root': {
        fontSize: '14px',
      },
    },
    columnMappingNoticeBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      minWidth: 0,
    },
    columnMappingNoticeTitle: {
      fontWeight: 600,
      color: '#0369a1',
      fontSize: '0.75rem',
      lineHeight: 1.3,
      letterSpacing: '0.01em',
    },
    columnMappingNoticeText: {
      color: '#64748b',
      fontSize: '0.72rem',
      lineHeight: 1.35,
      fontWeight: 400,
    },
    deactiveBin: {
      cursor: 'pointer',
      maxWidth: 'none',
      minWidth: 0,
      padding: 0,
      height: '100%',
      alignSelf: 'stretch',
      boxSizing: 'border-box',
      '& > .MuiPaper-root': {
        width: '100% !important',
        height: '100%',
        minHeight: BIN_MIN_H,
        boxSizing: 'border-box',
      },
    },
    binStyleA12: {
      width: '5.5rem',
      minHeight: BIN_MIN_H,
      height: 'auto',
      padding: '3px 4px',
    },
    binStyleCOOL12: {
      width: '100% !important',
      maxWidth: '100% !important',
      height: '100% !important',
      minHeight: `${COOL12_BIN_MIN} !important`,
      padding: '5px 4px',
      fontSize: '0.75rem',
      fontWeight: 700,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '@media (max-width: 640px)': {
      container: {
        gridTemplateColumns: '320px'
      }
    },
    '@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)':{
      container: {
        minWidth: '0',
        minHeight: '0',
        position: 'relative',
        gridGap: '0.5rem',
        gridTemplateColumns: '100%',
        width: '100%',
      },
      spacer: {
        height: '0'
      },
    },
    '@media only screen and (min-width:1280px) and (max-width:1366px) and (orientation:landscape)' :{
      container: {
        minWidth: '0',
        minHeight: '0',
        position: 'relative',
        gridGap: '0.5rem',
        gridTemplateColumns: '100%',
        width: '100%',
      },
      spacer: {
        height: '0'
      },
    }
  };
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/box-layout.styles.js